import type {RutaProd} from '../../../../runtime/rutas';
export default {"ruta":"/sistema/crm","alias":["/sistema/crm/Dashboard","/sistema/crm/Dashboard/Index"],"documento":"crm","filas":["127"],"acceso":"sesion","cita":"prod:Areas/CRM/Controllers/DashboardController.cs:26"} satisfies RutaProd;
